export const isNiaLoginType = (type?: string): boolean =>
	type ? type.toUpperCase() === 'NIA' : false;
